var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h' + _vm.level,{tag:"component",class:{
  'heading-1': _vm.level === 1,
  'heading-2': _vm.level === 2,
  'heading-3': _vm.level === 3,
  'heading-4': _vm.level === 4,
}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }